import { SiteLocale } from "@graphql/types/graphql";
import { ILocaleValue, ISitemapPage, IStaticPath } from "@types";

const getPublicLocaleFromCmsLocale = (locale: SiteLocale | undefined): string =>
  (locale ?? "nl_BE").split("_")[0];

export const generateRandomNumber = (min: number, max: number): number =>
  Math.random() * (max - min) + min;

export const getUrlSlug = (slug: string | string[] | undefined, getParentSlug?: boolean) => {
  if (Array.isArray(slug)) {
    if (getParentSlug) {
      return slug[0];
    }

    return slug[slug.length - 1];
  }

  return slug || "";
};

export const checkParentSlugIsUnique = (
  parent: ISitemapPage | null,
  slug: string | string[] | undefined,
  locale: SiteLocale,
  preview: boolean,
) =>
  !parent ||
  preview ||
  (Array.isArray(slug) &&
    slug?.join("/") === `${getParentSlugByLocale(parent, locale)}/${getUrlSlug(slug)}`);

const getParentSlugByLocale = (parent: ISitemapPage, targetLocale: SiteLocale): string | null => {
  const matchingSlug = parent.slugs.find((slug) => slug.locale === targetLocale);

  return matchingSlug ? matchingSlug.value : null;
};

export const generatePaths = (pages: any, nested?: boolean): IStaticPath[] => {
  const pathsArray: IStaticPath[] = [];

  pages.forEach((page: any) =>
    page.slugs.forEach((slugLocale: ILocaleValue) => {
      pathsArray.push({
        params: { slug: nested ? [slugLocale.value] : slugLocale.value },
        locale: getPublicLocaleFromCmsLocale(slugLocale.locale),
      });

      if (nested) {
        page.children?.forEach((child: any) => {
          child.slugs.forEach((childSlugLocale: ILocaleValue) => {
            pathsArray.push({
              params: { slug: [slugLocale.value, childSlugLocale.value] },
              locale: getPublicLocaleFromCmsLocale(slugLocale.locale),
            });
          });
        });
      }
    }),
  );

  return pathsArray;
};
